import { render, staticRenderFns } from "./SupplierForm.vue?vue&type=template&id=21a3f0da&scoped=true&"
import script from "./SupplierForm.vue?vue&type=script&lang=js&"
export * from "./SupplierForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierForm.vue?vue&type=style&index=0&id=21a3f0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a3f0da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VDialog,VRow,VSelect,VTextField})
